import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../utils/network-call/network-call";

export const AdminLicenseEditLoader = async (args: LoaderFunctionArgs) => {
    const getLicenseResponse = await networkCall(`/licenses/${ args.params.id }`);
    return { licenseId: args.params.id, getLicenseResponse };
};